import api from './client';

export interface AuditLogItem {
  id: string;
  userId?: string;
  userName?: string;
  userEmail?: string;
  action: string;
  entityType?: string;
  entityId?: string;
  description: string;
  metadata?: unknown;
  createdAt: string;
}

export interface AuditFilters {
  userId?: string;
  action?: string;
  from?: string; // RFC3339
  to?: string;   // RFC3339
  limit?: number;
  offset?: number;
}

export const auditAPI = {
  list: async (
    filters: AuditFilters = {},
  ): Promise<{ items: AuditLogItem[]; total: number }> => {
    const response = await api.get('/admin/activity', { params: filters });
    return response.data;
  },
  filters: async (): Promise<{
    actions: string[];
    users: Array<{ id: string; name: string; email: string }>;
  }> => {
    const response = await api.get('/admin/activity/filters');
    return response.data;
  },
  exportCsv: async (filters: AuditFilters = {}): Promise<Blob> => {
    const response = await api.get('/admin/activity/export', {
      params: filters,
      responseType: 'blob',
    });
    return response.data as Blob;
  },
};
